// extracted by mini-css-extract-plugin
export default {"contactInfo":"AssociationPage_contactInfo__eXDRc"};